import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { useOfflineStatus } from "../../utilities/useOfflineStatus";

interface OfflineManagerNotificationsProps {
	offlineMode: boolean;
	onChangeOfflineMode: (offlineMode: boolean) => void;
	offlineModeChangeMessage?: string;
	onDismissOfflineModeChangeMessage: () => void;
}

export function OfflineManagerNotifications(props: OfflineManagerNotificationsProps) {
	const { offlineMode, offlineModeChangeMessage } = props;
	const browserIsOffline = useOfflineStatus();

	const [goOnlinePrompt, setGoOnlinePrompt] = useState(false);
	const [goOfflinePrompt, setGoOfflinePrompt] = useState(false);
	const [updateAvailable, setUpdateAvailable] = useState(false);

	useEffect(() => {
		window.addEventListener("MakerNeedsUpdate", function (e) {
			setUpdateAvailable(true);
		});
	}, []);

	useEffect(() => {
		const browserIsOnline = !browserIsOffline;
		const onlineMode = !offlineMode;

		if(browserIsOffline !== offlineMode){
			setGoOfflinePrompt(onlineMode && browserIsOffline);
			setGoOnlinePrompt(offlineMode && browserIsOnline);
		} else {
			setGoOfflinePrompt(false);
			setGoOnlinePrompt(false);
		}
	}, [browserIsOffline, offlineMode]);

	const onGoOffline = () => {
		props.onChangeOfflineMode(true);
		setGoOfflinePrompt(false);
	};

	const onGoOnline = () => {
		props.onChangeOfflineMode(false);
		setGoOnlinePrompt(false);
	};

	if (updateAvailable) {
		return (
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={true}
				message="New version of Sermon Maker is available."
				action={
					<Button style={{ color: "#669ae2" }} size="small" onClick={() => window.location.reload()}>
						UPDATE
					</Button>
				}
			/>
		);
	}

	if (goOnlinePrompt) {
		return (
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={true}
				message="Internet connection detected"
				action={
					<Button style={{ color: "#669ae2" }} size="small" onClick={onGoOnline}>
						GO ONLINE
					</Button>
				}
			/>
		);
	}

	if (goOfflinePrompt) {
		return (
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={true}
				message="No internet connection detected"
				action={
					<Button style={{ color: "#669ae2" }} size="small" onClick={onGoOffline}>
						GO OFFLINE
					</Button>
				}
			/>
		);
	}

	if (offlineModeChangeMessage) {
		return (
			<Snackbar
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				open={true}
				message={offlineModeChangeMessage}
				onClose={props.onDismissOfflineModeChangeMessage}
				autoHideDuration={4000}
			/>
		);
	}

	return null;
}
